import 'src/styles/globals.css';

import type { AppProps } from 'next/app';
import Head from 'next/head';
import Script from 'next/script';

// add comscore

export const MyApp = ({ Component, pageProps }: AppProps) => {
  const property = `gtag('config', 'UA-193678100-21', {
    send_page_view: false
  });`;

  const gaScript = `window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());

          ${property}
          window.gtag('event', 'page_view', {
            page_path: window.location.pathname
          });`;

  const postMessageScript = () => {
    return {
      __html: `window.addEventListener('message', function () {
        window.top.postMessage(
          { height: document.body.scrollHeight, location: window.location.href },
          '*',
        );
      });`,
    };
  };

  return (
    <>
      <Head>
        <link href="https://fonts.gstatic.com" rel="preconnect" />
        <link
          href="https://fonts.googleapis.com/css2?family=Archivo+Narrow:ital,wght@0,400;0,600;1,600;1,700&family=Merriweather&display=swap"
          rel="stylesheet"
        />
        <link href="https://on3static.com/fonts/fonts.css" rel="stylesheet" />
        <meta
          content="font-src 'self' fonts.gstatic.com on3static.com;"
          httpEquiv="Content-Security-Policy"
        />
      </Head>
      <Script
        src="https://www.googletagmanager.com/gtag/js?id=UA-193678100-21"
        strategy="lazyOnload"
      />
      <Script id="google-analytics" strategy="lazyOnload">
        {gaScript}
      </Script>
      <Component {...pageProps} />
      <script dangerouslySetInnerHTML={postMessageScript()} id="post-message" />
    </>
  );
};

export default MyApp;
